export const libyanCities = [
  {
    label: 'طرابلس',
    value: 'tripoli',
    code: 'TP'
  },
  {
    label: 'بنغازي',
    value: 'benghazi',
    code: 'BZ'
  },
  {
    label: 'مصراتة',
    value: 'misrata',
    code: 'MS'
  },
  {
    label: 'الزاوية',
    value: 'zawiya',
    code: 'ZY'
  },
  {
    label: 'البيضاء',
    value: 'bayda',
    code: 'BD'
  },
  {
    label: 'طبرق',
    value: 'tobruk',
    code: 'TK'
  },
  {
    label: 'اجدابيا',
    value: 'ajdabiya',
    code: 'AD'
  },
  {
    label: 'زليتن',
    value: 'zliten',
    code: 'ZT'
  },
  {
    label: 'درنة',
    value: 'derna',
    code: 'DN'
  },
  {
    label: 'سبها',
    value: 'sabha',
    code: 'SH'
  },
  {
    label: 'صبراتة',
    value: 'sabratha',
    code: 'SB'
  },
  {
    label: 'كفرة',
    value: 'kufra',
    code: 'KF'
  },
  {
    label: 'المرج',
    value: 'marj',
    code: 'MJ'
  },
  {
    label: 'سرت',
    value: 'sirte',
    code: 'ST'
  },
  {
    label: 'غير',
    value: 'other',
    code: 'OT'
  }
]

export const exiosWorkingCountries = [
  {
    label: 'الصين',
    value: 'china',
    code: 'CN'
  },
  {
    label: 'الامارات',
    value: 'uae',
    code: 'UAE'
  },
  {
    label: 'امريكا',
    value: 'usa',
    code: 'USA'
  },
  {
    label: 'تركيا',
    value: 'turkey',
    code: 'TR'
  },
  {
    label: 'بريطانيا',
    value: 'uk',
    code: 'UK'
  }
]